import React, { useEffect, useState } from "react";
import MainPage from "./pages";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ArtistPage from "./pages/ArtistPage";

import Front1 from "./assets/front/1.webp";
import Front2 from "./assets/front/2.webp";
import Front3 from "./assets/front/3.webp";
import Front4 from "./assets/front/4.webp";
import Front5 from "./assets/front/5.webp";

import Main1 from "./assets/MAIN/1.webp";
import Main2 from "./assets/MAIN/2.webp";
import Main3 from "./assets/MAIN/3.webp";
import Main4 from "./assets/MAIN/4.webp";
import Main5 from "./assets/MAIN/5.webp";

import CB1 from "./assets/cb/1.webp";
import CB2 from "./assets/cb/2.webp";
import CB3 from "./assets/cb/3.webp";
import CB4 from "./assets/cb/4.webp";
import CB5 from "./assets/cb/5.webp";
import Snow from "./components/Snow";

import "./App.scss";

const isToday = (someDate) => {
  const today = new Date();
  return (
    someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
  );
};

const App = () => {
  const [data, setData] = useState([
    {
      dateText: "02.12",
      title: "Coldplay",
      url: "noel/coldplay",
      nombreGagnants: "2 gagnant.e.s",
      catchPhrase:
        "Aujourd'hui, tente de gagner <span>l'intégrale en CD de la discographie du groupe&nbsp;!</span>",
      lots: "",
      bgImg: Front1,
      date: new Date("2024-12-02"),
      formId: 42070,
      dotationImg: Main1,
      callbackPhrase: "En attendant écoute «Moon Music»",
      callbackImg: CB1,
      callbackLink: "https://WEA.lnk.to/MoonMusic-FullMoonEditionCT",
    },
    {
      dateText: "03.12",
      title: "Ed Sheeran",
      url: "noel/ed-sheeran",
      bgImg: Front2,
      nombreGagnants: "2 gagnant.e.s",
      catchPhrase:
        "Aujourd’hui, tente de gagner <span>un vinyle Tour Collection + une  veste en jean noire Tour Collection&nbsp;!</span>",
      lots: "",
      date: new Date("2024-12-03"),
      formId: 42071,
      dotationImg: Main2,
      callbackPhrase: "En attendant pré-enregistre +-=÷× [TOUR EDITION: LIVE]",
      callbackImg: CB2,
      callbackLink: "https://WEA.lnk.to/TOUREDITIONLIVECT",
    },
    {
      dateText: "04.12",
      title: "Dua Lipa",
      url: "noel/dua-lipa",
      nombreGagnants: "1 gagnant.e",
      bgImg: Front3,
      catchPhrase:
        "Aujourd’hui, tente de gagner <span>2 vinyles, 3 posters et des stickers&nbsp;!</span>",
      lots: "",

      date: new Date("2024-12-04"),
      formId: 42072,
      dotationImg: Main3,
      callbackPhrase:
        "En attendant, écoute son album «Live Live from the Royal Albert Hall»",
      callbackImg: CB3,
      callbackLink: "https://WEA.lnk.to/DuaLipa-LiveFromRoyalAlbertHallCT",
    },
    {
      dateText: "05.12",
      title: "Burna Boy",
      url: "noel/burna-boy",
      nombreGagnants: "2 gagnant.e.s",
      bgImg: Front4,
      catchPhrase:
        "Aujourd’hui, tente de gagner <span>l'intégrale de sa discographie en vinyle&nbsp;!</span>",
      lots: "",

      date: new Date("2024-12-05"),
      formId: 42073,
      dotationImg: Main4,
      callbackPhrase:
        "En attendant son retour, écoute son dernier single «Higher»",
      callbackImg: CB4,
      callbackLink: "https://WEA.lnk.to/BurnaBoyHigherCT",
    },
    {
      dateText: "06.12",
      title: "Bruno Mars",
      url: "noel/bruno-mars",
      nombreGagnants: "2 gagnant.e.s",
      bgImg: Front5,
      catchPhrase:
        "Aujourd'hui, tente de gagner <span>l'intégrale de sa discographie en vinyle&nbsp;!</span>",
      lots: "",

      date: new Date("2024-12-06"),
      formId: 42074,
      dotationImg: Main5,
      callbackPhrase:
        "En attendant, replonge-toi dans l'univers de Bruno en écoutant la playlist 100% Bruno Mars :",
      callbackImg: CB5,
      callbackLink: "https://TopsifyFR.lnk.to/BrunoMarsBOCT",
    },
  ]);

  const [_datas] = useState(data);

  return (
    <>
      <BrowserRouter>
        <Routes>
          {_datas
            .map((el) => el.url)
            .map((path) => (
              <Route
                key={path}
                path={path}
                element={<ArtistPage data={data} />}
              />
            ))}
          <Route
            path="*"
            element={
              <MainPage
                data={data}
                dataDate={_datas?.find((data) => isToday(data.date))}
              />
            }
          />
        </Routes>
      </BrowserRouter>
      <Snow />
    </>
  );
};

export default App;
